export default __webpack_public_path__ + "static/media/Vogel-mit-Ast.d83dca0f.webp";